<template>
  <div>
    <a-table
      :row-selection="{selectedRowKeys, onChange: onSelectChange}"
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <div slot="option">
        <a style="margin-right: 10px;" @click="applyHandle">应用</a>
        <a @click="seeHandle">查看</a>
      </div>
    </a-table>
    <a-modal v-model="visible" title="主营养指标(不含氨基酸)" width="80%" ok-text="关闭" cancel-text="返回">
      <a-tabs default-active-key="1" @change="tabChangeHandle">
        <a-tab-pane key="1" tab="动物类型">
          <AnimalTypeTab/>
        </a-tab-pane>
        <a-tab-pane key="2" tab="养分选择">
          <NutrientSelectionTab/>
        </a-tab-pane>
      </a-tabs>
      
    </a-modal>
  </div>
</template>
<script>
import AnimalTypeTab from './AnimalTypeTab';
import NutrientSelectionTab from './NutrientSelectionTab';

const columns = [
  {
    title: '表单名称',
    dataIndex: 'one',
  },
  {
    title: '代码',
    dataIndex: 'two',
  },
  {
    title: '优先级',
    dataIndex: 'three',
  },
  {
    title: '操作',
    dataIndex: 'option',
    scopedSlots: { customRender: 'option' }
  },
];
export default {
  components: {
    AnimalTypeTab,
    NutrientSelectionTab
  },
  data(){
    return {
      selectedRowKeys: [],
      columns,
      list: [{},{}],
      visible: false,
    }
  },
  methods: {
    onSelectChange(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys;
    },
    seeHandle(){
      this.visible = true;
    },
    applyHandle(){},
    tabChangeHandle(){},
  },
}
</script>
<style lang="scss" scoped>

</style>